import { FC, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getArticleDiscountById } from "../../app/services/articleDiscountService";
import { useAppDispatch } from "../../app/hooks";
import { useAccount, useMsal } from "@azure/msal-react";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import Form from "react-bootstrap/Form";
import {  
  Breadcrumb,
  Button,
  Col,  
  Row
} from "react-bootstrap";
import moment from "moment";

interface Props {}

const ArticleDiscountView: FC<Props> = () => {
  moment.locale("sv");
  const { articleDiscountId } = useParams<{
    articleDiscountId: string;
  }>();
  const dispatch = useAppDispatch();

  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  const articleDiscountData = useSelector(
    (state: RootState) => state.articleDiscount,
  );

  useEffect(() => {
    dispatch(
      getArticleDiscountById(instance, account, articleDiscountId),
    );
  }, [account, accounts, dispatch, instance, articleDiscountId]);

  return (
    <div>
      <Breadcrumb>
        <Breadcrumb.Item href="/article-discounts">
          Artikelrabatter
        </Breadcrumb.Item>
        <Breadcrumb.Item active>{articleDiscountId}</Breadcrumb.Item>
      </Breadcrumb>
      <hr />
      <Form>
        <Row>
          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Artikel</Form.Label>
              <Form.Control
                type="text"
                value={
                  articleDiscountData.articleDiscount.externalId
                }
                readOnly
                disabled
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Namn</Form.Label>
              <Form.Control
                type="text"
                value={articleDiscountData.articleDiscount.name}
                readOnly
                disabled
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Beskrivning</Form.Label>
              <Form.Control
                type="text"
                value={
                  articleDiscountData.articleDiscount.description
                }
                readOnly
                disabled
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Rabatt %</Form.Label>
              <Form.Control
                type="text"
                value={
                  articleDiscountData.articleDiscount
                    .discountPercentage
                }
                readOnly
                disabled
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Fastpris</Form.Label>
              <Form.Control
                type="text"
                value={
                  articleDiscountData.articleDiscount.forcedSalesPrice ?? ""
                }
                readOnly
                disabled
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Skapad</Form.Label>
              <Form.Control
                type="date"
                value={
                  articleDiscountData.articleDiscount.createdAt
                  ? new Date(articleDiscountData.articleDiscount.createdAt).toLocaleDateString()
                  : "-"
                }
                readOnly
                disabled
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6}>
            <Form.Group className="mb-3">
              <Form.Label>Uppdaterad</Form.Label>
              <Form.Control
                type="date"
                value={
                  articleDiscountData.articleDiscount.updatedAt
                    ? new Date(articleDiscountData.articleDiscount.updatedAt).toLocaleDateString()
                    : "-"
                }
                readOnly
                disabled
              />
            </Form.Group>
          </Col>
        </Row>
      </Form>

      <Row>
        <div className="text-end">
          <Button
            variant="primary"
            href={`/article-discounts/${articleDiscountId}/edit`}
          >
            Redigera
          </Button>
        </div>
      </Row>
    </div>
  );
};

export default ArticleDiscountView;
